import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { formatApiError } from "@/lib/api";
import { toast } from "sonner";

export default function Register() {
  const { register } = useAuth();
  const nav = useNavigate();
  const [form, setForm] = useState({ name: "", email: "", password: "" });
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const u = await register(form.email, form.password, form.name);
      toast.success(`Welcome, ${u.name}!`);
      nav("/account");
    } catch (err) {
      toast.error(formatApiError(err.response?.data?.detail));
    } finally { setLoading(false); }
  };

  return (
    <div className="container-x py-16 max-w-md" data-testid="register-page">
      <h1 className="font-serif text-4xl mb-2">Create your account</h1>
      <p className="text-sm text-muted-foreground mb-8">Join the AdiYogi Circle</p>
      <form onSubmit={submit} className="space-y-4">
        <input data-testid="reg-name" required value={form.name} onChange={(e) => setForm({...form, name: e.target.value})} placeholder="Full name" className="w-full border hairline rounded-lg px-3 py-2 bg-white outline-none focus:border-[#B8860B]" />
        <input data-testid="reg-email" required type="email" value={form.email} onChange={(e) => setForm({...form, email: e.target.value})} placeholder="Email" className="w-full border hairline rounded-lg px-3 py-2 bg-white outline-none focus:border-[#B8860B]" />
        <input data-testid="reg-password" required type="password" minLength={6} value={form.password} onChange={(e) => setForm({...form, password: e.target.value})} placeholder="Password (min 6 chars)" className="w-full border hairline rounded-lg px-3 py-2 bg-white outline-none focus:border-[#B8860B]" />
        <button disabled={loading} className="w-full btn-gold rounded-full py-3 text-xs uppercase tracking-widest" data-testid="reg-submit">{loading ? "Creating…" : "Create Account"}</button>
      </form>
      <div className="mt-6 text-sm text-center text-muted-foreground">
        Already have an account? <Link to="/login" className="gold-text">Sign in</Link>
      </div>
    </div>
  );
}
